<template>
  <div v-if="currentTables !== null && currentTables.length > 0">
    <b-overlay :show="isSending" no-wrap>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="pen" font-scale="3" animation="cylon"></b-icon>
        </div>
      </template>
    </b-overlay>
    La tua squadra gioca al tavolo
    <div v-if="currentTables[0].TriplicateIndex > 0" class="font-weight-bold" style="font-size: 3rem">
      Triplicato
    </div>
    <div v-else v-text="currentTables[0].table" class="font-weight-bold" style="font-size: 3rem"></div>
    Procedi con l'iscrizione autonoma
    <b-form-group>
      <b-form-radio-group
          v-model="selectedTableNumber"
          :options="availableTables"
          button-variant="outline-primary"
          buttons
          @change="scrollToTableLineup"
          class="roomSelector"
      ></b-form-radio-group>
    </b-form-group>
    <div v-if="selectedTableNumber !== -1 && selectedTable !== undefined" class="mt-4">
      <b-container ref="lineup">
        <b-form-row>
          <b-col>
            <b-button v-if="!isNsAvailableLine" variant="danger">Non disp.</b-button>
            <b-button v-else-if="selectedTable.N !== null" variant="warning"
                      v-text="getPlayerName(selectedTable.N)"></b-button>
            <b-button v-else variant="success" @click="seat(0)">Siedi in Nord</b-button>
          </b-col>
        </b-form-row>
        <b-form-row class="my-4">
          <b-col>
            <b-button v-if="!isEwAvailableLine" variant="danger">Non disp.</b-button>
            <b-button v-else-if="selectedTable.W !== null" variant="warning"
                      v-text="getPlayerName(selectedTable.W)"></b-button>
            <b-button v-else variant="success" @click="seat(3)">Siedi in Ovest</b-button>
          </b-col>
          <b-col>
            <b-button v-if="!isEwAvailableLine" variant="danger">Non disp.</b-button>
            <b-button v-else-if="selectedTable.E !== null" variant="warning"
                      v-text="getPlayerName(selectedTable.E)"></b-button>
            <b-button v-else variant="success" @click="seat(1)">Siedi in Est</b-button>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button v-if="!isNsAvailableLine" variant="danger">Non disp.</b-button>
            <b-button v-else-if="selectedTable.S !== null" variant="warning"
                      v-text="getPlayerName(selectedTable.S)"></b-button>
            <b-button v-else variant="success" @click="seat(2)">Siedi in Sud</b-button>
          </b-col>
        </b-form-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {get} from '@/lib/fetcher';

export default {
  name: "TableSubscribing",
  data() {
    return {
      isSending: false,
      selectedTableNumber: -1
    }
  },
  computed: {
    ...mapGetters({
      idTeam: 'tournament/teamId',
      teamCurrentSessionMap: 'players/teamCurrentSessionMap',
      currentSession: 'tournament/currentSession',
      currentRound: 'tournament/currentRound',
      players: 'players/teamPlayers',
      sectors: 'tournament/sector'
    }),

    availableTables() {

      const refTable = this.currentTables[0];
      if(refTable?.TriplicateIndex === 0) {
        return [
          {text: 'Sala aperta', value: refTable.table},
          {text: 'Sala chiusa', value: this.currentTables[1].table}
        ];
      }

      const nsTable = this.currentTables.find(t => t.NsEventId === this.idTeam);
      const ewTable = this.currentTables.find(t => t.EwEventId === this.idTeam);

      switch (nsTable?.TriplicateIndex) {
        case 0: {
          const tabRef = nsTable.table;
          const tab1 = nsTable.table;
          const tab2 = ewTable.table;
          return [
            {text: 'Tav ' + tabRef + ' sala aperta', value: tab1},
            {text: 'Tav ' + tabRef + ' sala chiusa', value: tab2}
          ]
        }

        case 1: {
          const tabRef = nsTable.table;
          const tab1 = ewTable.table;
          const tab2 = nsTable.table;
          return [
            {text: 'Tav ' + tabRef + ' sala chiusa', value: tab1},
            {text: 'Tav ' + (tabRef + 1) + ' sala aperta', value: tab2}
          ]
        }

        case 2: {
          const tabRef = nsTable.table;
          const tab1 = nsTable.table;
          const tab2 = ewTable.table;
          return [
            {text: 'Tav ' + (tabRef - 1) + ' sala aperta', value: tab2},
            {text: 'Tav ' + tabRef + ' sala aperta', value: tab1}
          ]
        }

        default:
          return []
      }
    },
    selectedTable() {
      const ref = this.currentTables[0];
      const that = this;
      return this.sectors.Phases[ref.phase].Series[ref.serie].Sessions[ref.session].Groups[ref.sector].Rounds[ref.round].Tables[that.selectedTableNumber];
    },
    currentTables() {
      const that = this;
      return this.teamCurrentSessionMap
          .filter(tbl => tbl.round === that.currentRound && tbl.session === that.currentSession)
          .sort((a, b) => a.Room - b.Room);
    },
    isNsAvailableLine() {
      if (this.selectedTable === undefined) return false;
      return this.idTeam === this.selectedTable.NsEventId;
    },
    isEwAvailableLine() {
      if (this.selectedTable === undefined) return false;
      return this.idTeam === this.selectedTable.EwEventId;
    },
    playersDictionary() {
      const ret = {};
      Object.values(this.players).forEach(plr => ret[plr.Code] = plr);
      return ret;
    }
  },
  methods: {
    scrollToTableLineup() {
      this.$nextTick(() => {
        var element = this.$refs["lineup"];

        this.$scrollTo(element);
      })
    },
    seat(seatNumber) {
      this.isSending = true;
      const ref = this.currentTables[0];
      const qrCode = ref.serie.toString().padStart(2, '0') + ref.sector.toString().padStart(2, '0') + this.selectedTableNumber.toString().padStart(3, '0') + seatNumber + this.selectedTable.Room;
      get("/api/subscribeViaQrCode/" + qrCode);

    },
    getPlayerName(playerCode) {
      return this.playersDictionary[playerCode]?.Name;
    }
  },
  watch: {
    teamCurrentSessionMap(newValue) {
      if (newValue.length > 0) {
        this.isSending = false;
      }
    }
  }
}
</script>

<style scoped>

>>> .roomSelector .btn {
  border: 1px solid #1B708D;
  color: #3396B8 !important;
  font-size: 1.5rem;
}

>>> .roomSelector .active {
  background-color: #3396B8 !important;
  color: white !important;
}
</style>
